import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import { clipTop, clipBottom } from "@/utils/pageFitMethod";
import { judgeFutureBabyVersion } from "@/utils/judgeVersion";
import BackTrack from "@/utils/backTrack";
import GeneralUtilsHelper from "@/utils/generalUtils";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import { judgeIsIosAndIsNewCamera } from "@/utils/judgeVersion";

var FutureBaby =
/*#__PURE__*/
function (_Vue) {
  _inherits(FutureBaby, _Vue);

  function FutureBaby() {
    var _this;

    _classCallCheck(this, FutureBaby);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FutureBaby).apply(this, arguments));
    _this.videoName = "";
    return _this;
  }

  _createClass(FutureBaby, [{
    key: "getVedioName",
    value: function () {
      var _getVedioName = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var videoType;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoType = this.lunchConfig && this.lunchConfig.launch_vip_video_local_resource ? "local" : "online";
                _context.next = 3;
                return GeneralUtilsHelper.getVideoFileUrl("future_baby.mp4", videoType);

              case 3:
                this.videoName = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getVedioName() {
        return _getVedioName.apply(this, arguments);
      }

      return getVedioName;
    }()
  }, {
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
      this.removeBackTrack();
    }
  }, {
    key: "addedBackTrack",
    value: function addedBackTrack() {
      var _this2 = this;

      //增加安卓返回键：
      BackTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this2.clickClose();
        }
      });
    }
  }, {
    key: "removeBackTrack",
    value: function removeBackTrack() {
      BackTrack.destroy(this.$route.name);
    }
  }, {
    key: "clickStart",
    value: function clickStart() {
      this.resetResultByName("futureBaby");
      judgeIsIosAndIsNewCamera() ? this.futureBabyIosNew() : judgeFutureBabyVersion() ? this.futureBabyNew().catch(function (err) {}) : this.futureBaby().catch(function (err) {});
    }
  }, {
    key: "clickStarPic",
    value: function clickStarPic() {
      this.routerPush({
        name: "chooseCelebrate",
        query: {
          from: "futureBaby"
        }
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.getVedioName();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.addedBackTrack();
    }
  }, {
    key: "clipTop",
    get: function get() {
      return clipTop();
    }
  }, {
    key: "clipBottom",
    get: function get() {
      return clipBottom();
    }
  }]);

  return FutureBaby;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], FutureBaby.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.FUTURE_BABY)], FutureBaby.prototype, "futureBaby", void 0);

tslib_1.__decorate([Action(types.FUTURE_BABY_NEW)], FutureBaby.prototype, "futureBabyNew", void 0);

tslib_1.__decorate([Action(types.FUTURE_BABY_IOSNEW)], FutureBaby.prototype, "futureBabyIosNew", void 0);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], FutureBaby.prototype, "routerPush", void 0);

tslib_1.__decorate([Mutation(types.RESET_RESULT_BY_NAME)], FutureBaby.prototype, "resetResultByName", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], FutureBaby.prototype, "lunchConfig", void 0);

FutureBaby = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    VideoPlayer: VideoPlayer
  }
})], FutureBaby);
export default FutureBaby;